import { ref } from 'vue';

const STORAGE_KEY = 'lexicontest_player_name';

export function usePlayerName() {
  const stored = localStorage.getItem(STORAGE_KEY);
  const name = ref(stored ?? '');

  function save(value: string): void {
    const trimmed = value.trim();
    if (trimmed.length === 0) return;
    localStorage.setItem(STORAGE_KEY, trimmed);
    name.value = trimmed;
  }

  return { name, save };
}
